<ion-header>
    <ion-item color="secondary">
      <ion-label>{{ title }}</ion-label>
    </ion-item>  
</ion-header>
<ion-content>
  <ion-list>
    <ion-radio-group name="ioc-selector" (ionChange)="close($event)">
      @for (option of iocSelectorOptions; let last = $last; track $index) {
        <ion-item [lines]="last ? 'none' : null">
          <ion-radio labelPlacement="end" justify="start" [value]="option.value" mode="md">{{ option.label }}</ion-radio>
        </ion-item>
      }
    </ion-radio-group>
    <div style.border-top="1px solid black">
      @if (showCancelButton) {
        <ion-button color="danger" (click)="cancel()" expand="block" fill="clear" >
          {{ 'Cancel' | translate }}
        </ion-button>
      }
    </div>

  </ion-list>
</ion-content>
